// This is a synchronous action, hence

import { getBrands } from "../../constants";
import { setOptionHighChart } from "../HighChart";

// thunk will not interfere.
export const resetDeepDiveDashboard = (isBackedClick) => {
  return (dispatch) => {
    dispatch({
      type: "RESET_DEEP_DIVE_DASHBOARD",
      isBackedClick: isBackedClick,
    });
  };
};
export const setDeepDiveTabLoader = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_DEEP_DIVE_TAB_LOADER", value });
  };
};
export const setDeepDiveDashboardLoader = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_DEEP_DIVE_DASHBOARD_LOADER", value });
  };
};
export const setInitialDeepDiveDashboardData = (dashboardData) => {
  // This action is used to set the initial data for the Deep Dive Dashboard.
  // When we deepdiving into a dashboard, we might want to set the initial state
  // of the dashboard data to avoid unnecessary API calls or state resets.

  return (dispatch) => {
    dispatch({ type: "SET_DEEP_DIVE_DASHBOARD_DATA", dashboardData });
  };
};
export const setDeepDiveDashboardData = (dashboardData) => {
  return (dispatch) => {
    dispatch({ type: "SET_DEEP_DIVE_DASHBOARD_DATA", dashboardData });
  };
};

export const setDeepDiveDashboardTemplateData = (dashboardTemplateData) => {
  return (dispatch) => {
    dispatch({
      type: "SET_DEEP_DIVE_DASHBOARD_TEMPLATE_DATA",
      dashboardTemplateData,
    });
  };
};
export const setIsDeepDiveInDashboardTemplateData = (isDeepDive = false) => {
  return (dispatch) => {
    dispatch({
      type: "SET_IS_DEEPDIVE_IN_DASHBOARD_TEMPLATE_DATA",
      isDeepDive,
    });
  };
};
export const setSectionsInDashboardTemplateData = (
  sections = [],
  isOnlyWidgets = false
) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SECTIONS_IN_DASHBOARD_TEMPLATE_DATA",
      sections,
      isOnlyWidgets,
    });
  };
};
export const setDeepDiveSelectedSectionIndex = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_DEEP_DIVE_SELECTED_SECTION_INDEX", value });
  };
};
export const setDeepDiveSectionFetchLoader = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_DEEP_DIVE_SECTION_FETCH_LOADER", value });
  };
};
export const setWidgetsInSection = (
  widgetLists = [],
  sectionId = null,
  sectionRes = null,
  singleBrands = [],
  brandGroupsList = []
) => {
  let updatedSectionData = {};
  if (sectionRes) {
    if (sectionRes?.duration) {
      updatedSectionData.duration = sectionRes?.duration?.from
        ? sectionRes?.duration
        : null;
      updatedSectionData.start_date = sectionRes?.duration?.from
        ? sectionRes?.duration?.from
        : null;
      updatedSectionData.end_date = sectionRes?.duration?.from
        ? sectionRes?.duration?.to
        : null;
      updatedSectionData.dateFilters = sectionRes?.duration?.from
        ? [
            {
              attribute: "CreatedDate",
              type: "datetime",
              columns: {
                from: sectionRes?.duration?.from,
                to: sectionRes?.duration?.to,
              },
            },
          ]
        : null;
    }
    if (sectionRes?.filters && Array.isArray(sectionRes?.filters)) {
      updatedSectionData.filters = sectionRes?.filters;
    }
    updatedSectionData.is_locked = !!sectionRes?.is_locked;

    let finalBrand_list = sectionRes?.brand_list
      ? getBrands(
          brandGroupsList,
          sectionRes?.brand_list,
          singleBrands,
          sectionRes?.brand_groups
        )
      : null;

    updatedSectionData.brand_list = finalBrand_list;
    updatedSectionData.brand_ids = sectionRes?.brand_list;
    updatedSectionData.brand_groups = sectionRes?.brand_groups;
    updatedSectionData.profile_filters_list = sectionRes?.profile_filters_list;
    updatedSectionData.relative_duration = sectionRes?.relative_duration;
    updatedSectionData.widgets = widgetLists;
  }
  return (dispatch) => {
    dispatch(setOptionHighChart(null));
    dispatch({
      type: "SET_WIDGETS_IN_SECTION",
      sectionId,
      updatedSectionData,
    });
  };
};
export const setDashboardCalledApiListInDeepDiveTemplateData = (value = []) => {
  return (dispatch) => {
    dispatch({
      type: "SET_DASHBOARD_CALLED_API_LIST_IN_DEEPDIVE_TEMPLATE_DATA",
      dashboard_called_api_list: value,
    });
  };
};
export const setWidgetGraphDataInDeepDiveTemplateData = (
  value,
  sectionIndex,
  widgetIndex,
  body,
  graphObject,
  quickFilterDropdownListInNoData = null
) => {
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_GRAPH_DATA_IN_DEEPDIVE_TEMPLATE_DATA",
      graphData: value,
      sectionIndex,
      widgetIndex,
      body,
      graphObject,
      quickFilterDropdownListInNoData,
    });
  };
};
export const setClearDeepDiveDashboardWidgetGraphData = (
  sectionIndex,
  widgetIndex,
  widget_id
) => {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_WIDGET_GRAPH_DATA_IN_DEEPDIVE_TEMPLATE_DATA",
      sectionIndex: sectionIndex,
      widgetIndex: widgetIndex,
      widget_id: widget_id,
    });
  };
};

export const setWidgetAIGeneratedInsightsOpenStatusInDeepDiveDashboard = (
  open,
  sectionIndex,
  widgetIndex,
  clear
) => {
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_AI_GENERATED_INSIGHTS_STATUS_IN_DEEPDIVE_TEMPLATE_DATA",
      sectionIndex: sectionIndex,
      widgetIndex: widgetIndex,
      open,
      clear,
    });
  };
};
export const setWordcloudColourInDeepDiveDashboard = (
  wordcloudColor,
  sectionIndex,
  widgetIndex,
  clearData
) => {
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_WORDCLOUD_COLOUR_IN_DEEPDIVE_TEMPLATE_DATA",
      sectionIndex: sectionIndex,
      widgetIndex: widgetIndex,
      wordcloudColor,
      clearData,
    });
  };
};

export const setDefaultSortByValueInMetaDataInDeepDiveDashboard = (
  sectionIndex,
  widgetIndex,
  defaultValue
) => {
  return (dispatch) => {
    dispatch({
      type: "SET_DEFAULT_SORT_BY_VALUE_IN_WIDGET_METADATA_IN_DEEPDIVE_TEMPLATE_DATA",
      sectionIndex,
      widgetIndex,
      defaultValue,
    });
  };
};
export const setSortByChangeInMetaDataInDeepDiveDashboard = (
  sectionIndex,
  widgetIndex,
  clearData,
  action_case,
  updatedKeysObject = null
) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SORT_BY_CHANGES_IN_WIDGET_METADATA_IN_DEEPDIVE_TEMPLATE_DATA",
      sectionIndex: sectionIndex,
      widgetIndex: widgetIndex,
      clearData,
      action_case,
      updatedKeysObject,
    });
  };
};
